<template>
  <div class="service-fee">
    <div class="service-fee-table">
      <vxe-toolbar size="mini" v-if="!disabled">
        <template v-slot:buttons>
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新建</el-button
          >
          <el-button @click="editRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >编辑</el-button
          >
          <el-button @click="importHandler" size="small" type="primary" class="vxe-btn-primary"
            >导入</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
      </vxe-toolbar>
      <vxe-toolbar size="mini" v-else>
        <template v-slot:buttons>
          <el-button @click="exportExcel" size="small" type="primary" class="vxe-btn-primary"
            >导出</el-button
          >
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="serviceFeeRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        height="300"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :edit-render="item.editRender"
          :visible="item.visible"
        >
          <template v-slot="{ row }">
            <template v-if="item.field == 'chargeUnit'">
              <span>{{ row['chargeUnitName'] }}</span>
            </template>
            <template v-else-if="item?.field == 'cubeType'">
              <span>{{ getUnitName('cube', row[item.field]) }}</span>
            </template>
            <!-- <template v-else-if="item?.field == 'qtyUnit'">
              <span>{{ getUnitName('qty', row[item.field]) }}</span>
            </template> -->
            <template v-else>
              <span>{{ row[item.field] }}</span>
            </template>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
    <SiruiUpload
      ref="siruiUpload"
      :isShowDownTemplateBtn="true"
      @ossSuccess="importSuccess"
      :action="getImportUrl"
      source="intermodality"
      :data="importData"
    />
    <EditServiceFeeDialog
      ref="dialogRef"
      @confirmHandler="confirmHandler"
      :otherTitle="otherTitle"
    ></EditServiceFeeDialog>
  </div>
</template>

<script>
  import { chartColumns, quotationRuleColumns } from './columns.js';
  import IntermodalityCommonMixin from '@/pages/intermodality/common/mixins/IntermodalityCommonMixin';
  import EditServiceFeeDialog from './editServiceFeeDialog.vue';
  import SiruiUpload from '@/components/SiruiUpload';
  import API from '@/api/intermodality/contract.js';
  // import BASEAPI from '@/api/dataBase.js';
  export default {
    name: 'ServiceFeeChart',
    components: {
      EditServiceFeeDialog,
      SiruiUpload,
    },
    mixins: [IntermodalityCommonMixin],
    props: {
      disabled: {
        type: Boolean,
        default: () => false,
      },
      otherTitle: {
        type: String,
        default: () => '服务询报价',
      },
      tableDataList: {
        type: Array,
        default: () => [],
      },
      routes: {
        type: Array,
        default: () => [],
      },
      cargos: {
        type: Array,
        default: () => [],
      },
      selectedServices: {
        type: Array,
        default: () => [],
      },
      selectedProducts: {
        type: Array,
        default: () => [],
      },
      contractCode: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        // tableRules,
        routeList: [],
        cargoList: [],
        products: [],
        services: [],
      };
    },
    methods: {
      async exportExcel() {
        if (!this.selectionList.length) {
          return this.$message.error('请先选择数据再导出');
        }
        let ids = this.selectionList.map((item) => item.tempId);
        const params = {
          ids,
          contractCode: this.contractCode,
        };
        let { data } = await this.$axios.post(API.EXPORT_SERVICEFEE, params);
        if (data.code == 0) {
          window.location.href = data.data;
          this.$message.success('操作成功');
        } else {
          this.$message.error(data.msg);
        }
      },
      clearSelection() {
        this.$refs.serviceFeeRef.clearCheckboxRow();
        this.selectionList = [];
      },
      async confirmHandler(data, isEdit) {
        if (isEdit) {
          const list = this.$refs.serviceFeeRef?.getTableData()?.fullData;
          const index = list.findIndex((item) => item._XID == data.xid);
          delete data.xid;
          list.splice(index, 1, data);
          this.tableData = list;
        } else {
          await this.insertEvent(data, 0);
          this.tableData = this.getTableData();
        }
        this.$emit('handleChartChange', 'serviceQuotation', this.tableData);
      },
      // 新增行
      async newRowHandler() {
        if (this.routeList && this.routeList?.length == 0) {
          this.$message.error('请先选择路线！');
          return;
        }
        if (this.cargoList && this.cargoList?.length == 0) {
          this.$message.error('请先选择商品！');
          return;
        }
        if (this.services && this.services.length == 0) {
          this.$message.error('请先勾选服务！');
          return;
        }
        console.log(this.services, '服务列表');
        this.clearSelection();
        this.$refs.dialogRef.openModal(
          {},
          this.cargoList,
          this.routeList,
          this.products,
          this.services
        );
      },
      //编辑
      async editRowHandler() {
        if (this.selectionList.length && this.selectionList.length == 1) {
          let item = { ...this.selectionList[0] };
          this.$refs.dialogRef.openModal(
            item,
            this.cargoList,
            this.routeList,
            this.products,
            this.services
          );
          this.clearSelection();
        } else {
          this.$message.error('请勾选一条数据进行编辑');
        }
      },

      async insertEvent(rowData = {}, index = 0) {
        console.log(rowData, index);
        const $table = this.$refs.serviceFeeRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          // await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteBtnClickHandler() {
        // if (!this.selectionList.length || this.selectionList.length != 1) {
        //   this.$message.error('请勾选一条数据进行删除');
        //   return;
        // }
        if (this.selectionList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.serviceFeeRef.removeSelecteds();
            this.tableData = this.getTableData();
            this.$emit('handleChartChange', 'serviceQuotation', this.tableData);
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
      handleChange(row, field) {
        console.log(row, field, '行');
      },
      async closeEditTableHandler() {
        console.log('关闭');
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.serviceFeeRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
      importHandler() {
        if (this.routeList && this.routeList?.length == 0) {
          this.$message.error('请先选择路线！');
          return;
        }
        if (this.cargoList && this.cargoList?.length == 0) {
          this.$message.error('请先选择商品！');
          return;
        }
        if (this.services && this.services.length == 0) {
          this.$message.error('请先勾选服务！');
          return;
        }
        this.$refs.siruiUpload.openDialog(true, this.otherTitle == '服务计费规则' ? '097' : '096');
      },
      async importSuccess(response) {
        if (response.msg && response.msg.includes('导入失败')) {
          window.open(response.data);
          return;
        }
        let list = response.data;
        await this.$refs.serviceFeeRef.insertAt(list, -1);
        this.tableData = this.getTableData();
        this.$emit('handleChartChange', 'serviceQuotation', this.tableData);
      },
    },
    computed: {
      columns() {
        if (this.otherTitle == '服务计费规则') {
          return quotationRuleColumns;
        }

        return chartColumns;
      },
      importData() {
        let serviceNames = [];
        if (this.services && this.services.length != 0) {
          serviceNames = this.services.join(',');
        }
        return {
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          belongTenantCode: this.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.access_token,
          cargos: JSON.stringify(this.cargoList),
          routes: JSON.stringify(this.routeList),
          serviceTypeName: serviceNames,
        };
      },
      getImportUrl() {
        if (this.otherTitle == '服务计费规则') {
          return '/sales/mto/contract/importServiceChargeRules';
        }

        return '/sales/mtoProject/importServiceChargeRules';
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
      cargos: {
        handler(val) {
          this.cargoList = val;
        },
        immediate: true,
        deep: true,
      },
      routes: {
        handler(val) {
          this.routeList = val;
        },
        immediate: true,
        deep: true,
      },
      selectedServices: {
        handler(val) {
          this.services = val;
        },
        immediate: true,
        deep: true,
      },
      selectedProducts: {
        handler(val) {
          this.products = val;
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {},
  };
</script>

<style lang="scss" scoped>
  .service-fee {
    background: #fff;

    .service-fee-table {
      padding: 10px;
      box-sizing: border-box;
    }
  }
</style>
